import * as React from 'react'
import { StyleguideExample, StyleguidePart } from '../../../../../Shared/Hoppinger.Styleguide/Frontend'
import { typographyOtherTokens, typographyTextTokens, typographyTitleTokens } from '../tokens/typography.sg'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ObjectsTypography = () => (
  <>
    <StyleguidePart title="Titles" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <>
          {typographyTitleTokens.map((token, key, arr) => {
            return (
              <div key={key}>
                <p className={`${token.prefix}--${token.size}`}>
                  Vulputate Commodo Sollicitudin Fringilla Nullam - {token.size.toUpperCase()}
                </p>
                {key + 1 != arr.length ? <br /> : <></>}
              </div>
            )
          })}
        </>
      </StyleguideExample>
    </StyleguidePart>

    <StyleguidePart title="Text" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <>
          {typographyTextTokens.map((token, key, arr) => {
            return (
              <div key={key}>
                <p className={`${token.prefix}--${token.size}`}>
                  Vulputate Commodo Sollicitudin Fringilla Nullam. Etiam porta sem malesuada magna mollis euismod -{' '}
                  {token.size.toUpperCase()}
                </p>
                {key + 1 != arr.length ? <br /> : <></>}
              </div>
            )
          })}
        </>
      </StyleguideExample>
    </StyleguidePart>
    <StyleguidePart title="Other" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <>
          {typographyOtherTokens.map((token, key, arr) => {
            return (
              <div key={key} style={{ marginBottom: '1.5rem' }}>
                <span className={`${token.prefix}--${token.size}`}>
                  {token.prefix == 'tag'
                    ? 'Fringilla Nullam'
                    : 'Vulputate Commodo Sollicitudin Fringilla Nullam. Etiam porta sem malesuada magna mollis euismod.'}
                </span>
                - {`${token.prefix} ${token.size.toUpperCase()}`}
                {key + 1 != arr.length ? <br /> : <></>}
              </div>
            )
          })}
        </>
      </StyleguideExample>
    </StyleguidePart>

    <StyleguidePart title="WYSIWYG" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <div className="text--styled">
          {(['h3', 'h4', 'h5', 'h6'] as const).map((heading, i) => {
            const isOdd = i % 2 == 1
            const Tag = heading
            const FormatTag = isOdd ? 'strong' : 'em'
            const ListTag = isOdd ? 'ol' : 'ul'
            return (
              <React.Fragment key={heading}>
                <Tag>Vulputate Commodo Sollicitudin Fringilla Nullam - {heading.toUpperCase()}</Tag>
                <p>
                  Quis gravida magna mi a libero. Fusce vulputate eleifend sapien.{' '}
                  <FormatTag>Vestibulum purus quam</FormatTag>, scelerisque ut, mollis sed, nonummy id, metus. Nullam
                  accumsan lorem in dui. Leo eget bibendum sodales, augue velit cursus nunc.
                </p>
                <p>
                  Scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Leo eget bibendum
                  sodales, augue velit cursus nunc.
                </p>

                <ListTag>
                  <li>Vestibulum purus quam scelerisque ut</li>
                  <li>Scelerisque ut, mollis sed, nonummy id, metus</li>
                  <li>Nullam accumsan lorem in dui</li>
                </ListTag>
              </React.Fragment>
            )
          })}
        </div>
      </StyleguideExample>
    </StyleguidePart>
  </>
)
